module.exports = __webpack_public_path__ + "img/exam2.6921b57b.png";